import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import {
  DuplicateProposalInput,
  DuplicateProposalMutation,
} from '@/gql/graphql';

const DUPLICATE_PROPOSAL_MUTATION = graphql(`
  mutation DuplicateProposal($input: DuplicateProposalInput!) {
    duplicateProposal(input: $input) {
      publicId
      project {
        publicId
        customer {
          name
        }
      }
    }
  }
`);

const useDuplicateProposal = (args?: {
  options?: UseMutationOptions<
    DuplicateProposalMutation,
    unknown,
    DuplicateProposalInput
  >;
}) => {
  return useMutation({
    mutationFn: (input: DuplicateProposalInput) => {
      return gqlClient.request(DUPLICATE_PROPOSAL_MUTATION, { input });
    },
    ...args?.options,
  });
};

export default useDuplicateProposal;
